import Icon from '../../components/Icon.vue'

Icon.register({"brands/pagelines":{"width":384,"height":512,"paths":[{"d":"M384 312.7C328.9 449.4 196.9 366.7 196.9 366.7 156.4 448.5 89.5 501.1 12.3 501.4-3.8 501.4-4.3 477 12.3 477 76.7 476.7 132.8 434.3 169.5 366.9 128.4 382.8 50.9 394.8 7.9 284.7 116.9 239.8 167 295.9 186.2 330.2 196.1 305.8 203.2 279.3 207.8 250.5 207.8 250.5 68.1 272.4 58.3 152.4 177.4 104.5 210.9 229.1 210.9 229.1 212.5 212.4 214.2 176.5 214.2 175.7 214.2 175.7 107.9 102 176.1 10.5 300.7 53.5 237.5 172.9 237.5 172.9 238 174.5 238 196.7 237.5 206.3 237.5 206.3 282.7 117.3 373.9 148.8 369.7 282.8 232 255.2 232 255.2 227.6 282.6 220.8 308.6 212 332.7 212 332.7 295 240.9 384 312.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pagelines.js
// module id = hlZz
// module chunks = 0